<template>
    <b-form-group
        :state="isValid"
        :invalid-feedback="invalidFeedback"
        :description="helpText"
    >
        <template v-slot:label>
            <label class="form-label" :for="fieldId">{{field.label}}: <slot></slot></label>
        </template>

        <b-textarea
            :id="fieldId"
            :value="value"
            :rows="rows"
            :state="isValid"
            :placeholder="placeholder || $t('textarea.placeholder')"
            :lazy="lazy"
            @change="changeValue"
            @input="changeValue"
        />

    </b-form-group>
</template>

<script>
    import fieldMixin from "@/components/fields/FieldMixin";

    export default {
        name: "TextAreaField",
        mixins: [fieldMixin],
        props: {
            rows: {
                type: [Number, String],
                default: 2
            },
            placeholder: {
                type: String,
                default: '',
            },
            lazy: {
                type: Boolean,
                default: true
            }
        },
    };
</script>

<style scoped>

    textarea::-webkit-input-placeholder {
        color: lightgrey;
    }

    textarea:-moz-placeholder { /* Firefox 18- */
        color: lightgrey;
    }

    textarea::-moz-placeholder {  /* Firefox 19+ */
        color: lightgrey;
    }

    textarea:-ms-input-placeholder {
        color: lightgrey;
    }

</style>